export enum ITEM_NAME {
  // Consumables
  SMALL_POTION = "small-potion",
  POTION = "potion",
  REVIVE = "revive",
  BERRY_JUICE = "berry-juice",
  FRESH_WATER = "fresh-water",
  SODA_POP = "soda-pop",
  LEMONADE = "lemonade",
  MOOMOO_MILK = "moomoo-milk",

  // Evolution Stones
  FIRE_STONE = "fire-stone",
  WATER_STONE = "water-stone",
  THUNDER_STONE = "thunder-stone",
  LEAF_STONE = "leaf-stone",
  ICE_STONE = "ice-stone",
  MOON_STONE = "moon-stone",
  SUN_STONE = "sun-stone",
  DUSK_STONE = "dusk-stone",
  DAWN_STONE = "dawn-stone",
  SHINY_STONE = "shiny-stone",
  LINK_CABLE = "link-cable",
  // Evolution Items
  ADAMANT_ORB = "adamant-orb",
  AUSPICIOUS_ARMOR = "auspicious-armor",
  DUBIOUS_DISC = "dubious-disc",
  ELECTIRIZER = "electirizer",
  KINGS_ROCK = "king's-rock",
  MAGMARIZER = "magmarizer",
  MALICIOUS_ARMOR = "malicious-armor",
  METAL_COAT = "metal-coat",
  OVAL_STONE = "oval-stone",
  PRISM_SCALE = "prism-scale",
  PROTECTOR = "protector",
  RAZOR_CLAW = "razor-claw",
  RAZOR_FANG = "razor-fang",
  REAPER_CLOTH = "reaper-cloth",
  SACHET = "sachet",
  UPGRADE = "upgrade",
  WHIPPED_DREAM = "whipped-dream",
  DRAGON_GEM = "dragon-gem",
  FAIRY_GEM = "fairy-gem",
  FLYING_GEM = "flying-gem",
  NUGGET = "nugget",
  BIG_NUGGET = "big-nugget",
  PEARL = "pearl",
  BIG_PEARL = "big-pearl",
  STARDUST = "stardust",
  STAR_PIECE = "star-piece",
  GOLD_LEAF = "gold-leaf",
  SAPPHIRE = "sapphire",
  RUBY = "ruby",
  EMERALD = "emerald",
  DIAMOND = "diamond",
  BASIL = "basil",
  KIWI = "kiwi",
  FANCY_APPLE = "fancy-apple",
  SWEET_APPLE = "sweet-apple",
  SYRUPY_APPLE = "syrupy-apple",
  TART_APPLE = "tart-apple",
  BERRY_SWEET = "berry-sweet",
  CLOVER_SWEET = "clover-sweet",
  FLOWER_SWEET = "flower-sweet",
  LOVE_SWEET = "love-sweet",
  RIBBON_SWEET = "ribbon-sweet",
  STAR_SWEET = "star-sweet",
  STRAWBERRY_SWEET = "strawberry-sweet",
  CANDY_RED = "candy-red",
  CANDY_BLUE = "candy-blue",
  CANDY_BROWN = "candy-brown",
  CANDY_GRAY = "candy-gray",
  CANDY_GREEN = "candy-green",
  CANDY_PINK = "candy-pink",
  CANDY_PURPLE = "candy-purple",
  CANDY_YELLOW = "candy-yellow",
  EXP_CANDY_XL = "exp.-candy-xl",
  AMULET_COIN = "amulet-coin",
  BRIGHT_POWDER = "bright-powder",
  DAMP_ROCK = "damp-rock",
  DRAGON_FANG = "dragon-fang",
  DRAGON_SCALE = "dragon-scale",
  FAIRY_FEATHER = "fairy-feather",
  GOLD_BOTTLE_CAP = "gold-bottle-cap",
  HARD_STONE = "hard-stone",
  MAGNET = "magnet",
  MINT_ATTACK = "mint-attack",
  ARMORITE_ORE = "armorite-ore",
  DYNITE_ORE = "dynite-ore",
  BLACK_AUGURITE = "black-augurite",
  CHALKY_STONE = "chalky-stone",
  COMET_SHARD = "comet-shard",
  CRYSTAL_CLUSTER = "crystal-cluster",
  DEEP_SEA_SCALE = "deep-sea-scale",
  DEEP_SEA_TOOTH = "deep-sea-tooth",
  METAL_ALLOY = "metal-alloy",
  BLACK_FLUTE = "black-flute",
  BLUE_FLUTE = "blue-flute",
  BEACH_GLASS = "beach-glass",
  BIG_MUSHROOM = "big-mushroom",
  BLUE_PETAL = "blue-petal",
  HONEY = "honey",
  PEAT_BLOCK = "peat-block",
  CHIPPED_POT = "chipped-pot",
  CRACKED_POT = "cracked-pot",
  GALARICA_CUFF = "galarica-cuff",
  GALARICA_WREATH = "galarica-wreath",
  MASTERPIECE_TEACUP = "masterpiece-teacup",
  SCROLL_OF_DARKNESS = "scroll-of-darkness",
  SCROLL_OF_WATERS = "scroll-of-waters",
  UNREMARKABLE_TEACUP = "unremarkable-teacup",
  SHOP_TICKET = "shop-ticket",

  // Held Items
  NEVER_MELT_ICE = "never-melt-ice",
  SILK_SCARF = "silk-scarf",
  SHARP_BEAK = "sharp-beak",
  SOOTHE_BELL = "soothe-bell",
  DESTINY_KNOT = "destiny-knot",
  MYSTIC_WATER = "mystic-water",
  MIRACLE_SEED = "miracle-seed",
  METRONOME = "metronome",
  SNOWBALL = "snowball",
}
